var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 11.2864V8.55103C12.666 6.59779 13.9993 3.99987 15.9993 2.66667C17.9993 4.00001 19.3326 6.59779 19.3326 8.55103V11.2864C19.3326 11.7322 19.5554 12.1485 19.9264 12.3958L20.7389 12.9375C21.1098 13.1848 21.3326 13.6011 21.3326 14.0469V16H10.6661L10.666 14.0469C10.666 13.6011 10.8888 13.1848 11.2597 12.9375L12.0722 12.3958C12.4432 12.1485 12.666 11.7322 12.666 11.2864Z",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 29.3333C27.8403 29.3333 29.3327 27.7415 29.3327 25.7777C29.3327 23.8141 27.8403 22.2223 25.9993 22.2223C25.9993 20.2585 24.5069 18.6667 22.666 18.6667",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 29.3333C4.1584 29.3333 2.66602 27.7415 2.66602 25.7777C2.66602 23.8141 4.1584 22.2223 5.99935 22.2223C5.99935 20.2585 7.49174 18.6667 9.33268 18.6667",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 19.3333V28",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 19.3333V24",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP15);
export default __webpack_public_path__ + "static/media/p15.e43f3c2e092dedc697acaf9568bed224.svg";
export { ForwardRef as ReactComponent };